import(/* webpackMode: "eager" */ "/workspace/custom/CustomBreadcrumbs.jsx");
import(/* webpackMode: "eager" */ "/workspace/node_modules/next/dist/client/link.js")